module.exports = __webpack_public_path__ + "static/img/busBg.7f1b2ea4.png";